import { create } from 'zustand'

interface GlobalThemeState {
  colorPrimary: string
  // eslint-disable-next-line no-unused-vars
  setColorPrimary: (color: string) => void
}

const useGlobalThemeStore = create<GlobalThemeState>((set) => ({
  colorPrimary: '#0087E1',
  setColorPrimary: (color: string) => {
    set({
      colorPrimary: color,
    })
  }
}))

export default useGlobalThemeStore